<template>
  <v-container fluid>
    <v-card>
      <v-toolbar>
        <v-btn text @click="$refs.studyGroupSchedule.prev()">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-toolbar-title class="mx-3">
          {{ $moment(focus).format('MMMM YYYY') }}
        </v-toolbar-title>
        <v-btn text @click="$refs.studyGroupSchedule.next()">
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>

        <v-spacer></v-spacer>
        <v-btn color="primary" class="box-shadow" @click="generatePreparationDays">Generate</v-btn>
      </v-toolbar>
      <v-card-text>
        <v-calendar ref="studyGroupSchedule"
                    :now="today"
                    type="month"
                    v-model="focus"
                    :event-color="getEventColor"
                    :events="preparation_days"

                    :interval-minutes="90"
                    :interval-count="16"
                    :interval-height="40"
                    @click:date="create_item_dialog = !create_item_dialog"
                    @click:event="openEditDialog"
                    @change="loadData"

        ></v-calendar>
      </v-card-text>
    </v-card>

    <v-dialog v-model="create_item_dialog" max-width="400px">
      <v-form @submit="createPreparationDay">
        <v-card>
          <v-card-text>
            <v-select label="Choose practice area"
                      v-model="practice_area_id"
                      :items="practice_areas"
                      item-text="name"
                      item-value="id"
            />
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="justify-center">
            <v-btn color="primary" @click="create_item_dialog = !create_item_dialog">Cancel</v-btn>
            <v-btn color="success" type="submit" :disabled="!practice_area_id">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="selected_item_dialog" max-width="400px">
      <v-form @submit="destroyPreparationDay">
        <v-card>
          <v-card-title v-if="selected_item">Delete {{ selected_item.name }} ?</v-card-title>
          <v-divider/>
          <v-card-actions class="justify-center">
            <v-btn color="primary" @click="selected_item_dialog = !selected_item_dialog">Cancel</v-btn>
            <v-btn color="error" type="submit" >Delete</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-container>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  props: {
    course: {
      type: Object,
      default: null
    },
    study_group: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    dates_range: null,
    today: '',
    focus: '',
    preparation_day_items: [],
    preparation_day_dialog: false,
    create_item_dialog: false,
    practice_area_id: null,
    selected_item_dialog: false,
    selected_item: null,
    api_errors: []
  }),
  computed: {
    ...mapGetters({
      session_types: 'getSessionTypes',
      practice_areas: 'getPracticeAreas',
    }),
    preparation_days: function () {
      let items = []
      if(this.study_group) {
        items.push({
          name: 'Study period',
          start: this.study_group.study_period[0],
          end: this.study_group.study_period[1],
          color: 'success'
        })
      }

      if (this.preparation_day_items.length > 0) {
        items.push(...this.preparation_day_items)
      }
      return items
    }
  },
  created() {
    this.today = this.$currentTime().format('YYYY-MM-DD')
    this.focus = this.$currentTime().format('YYYY-MM-DD')
  },
  methods: {
    async loadData({start, end }) {
      this.dates_range = {start, end }
      let url = `api/study-groups/${this.$route.params.study_group_id}/preparation-days`
      this.preparation_day_items = await this.axios.get(url, { params: {date_from: start.date, date_to: end.date}})
          .then(({data}) => data.data)

    },
    getEventColor(event){
      // eslint-disable-next-line no-prototype-builtins
      if(event.hasOwnProperty('color')) return event.color
      return 'primary'
    },
    createPreparationDay(e) {
      e.preventDefault()
      this.api_errors = []
      let url = `api/study-groups/${this.$route.params.study_group_id}/preparation-days`
      this.axios.post(url, {practice_area_id: this.practice_area_id, date: this.focus})
          .then(() => {
            this.create_item_dialog = false
            this.loadData(this.dates_range)
          })
          .catch(error => { this.api_errors = error.response.data.errors})
    },
    openEditDialog({event}) {
      this.selected_item = event
      this.selected_item_dialog = true
    },
    destroyPreparationDay(e) {
      e.preventDefault()
      this.api_errors = []
      let url = `api/study-groups/${this.$route.params.study_group_id}/preparation-days/${this.selected_item.id}`
      this.axios.delete(url).then(() => {
        this.selected_item_dialog = false
        this.selected_item = null
        this.loadData(this.dates_range)
      })
    },
    generatePreparationDays() {
      let url = `api/study-groups/${this.$route.params.study_group_id}/preparation-days/generate`
      this.axios.post(url).then(() => {
        this.loadData(this.dates_range)
      })
    }
  }
}
</script>